export const FIELD_VARIANTS = ['default', 'warning', 'success', 'danger'];
export const FIELD_SIZES = ['small', 'medium', 'large'];
export const BUTTON_SIZES = [...FIELD_SIZES, 'icon', 'icon-small'];
export const BUTTON_VARIANTS = ['primary', 'secondary', 'tertiary', 'danger'];
export const MODAL_VARIANTS = ['fullpagesheet', 'pagesheet', 'formsheet', 'dialog', 'default'];
